var map = {
	"./1950.png": 25447,
	"./1960.png": 53181,
	"./1970.png": 17891,
	"./1980.png": 78865,
	"./1990.png": 55297,
	"./2000.png": 79246,
	"./2010.png": 30480,
	"./2020.png": 4330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27195;